import React, { useContext } from 'react';
import UserItem from './UserItem';
import Spinner from '../layouts/Spinner';
import PropTypes from 'prop-types';
import GithubContext from '../../context/github/githubContext';


const Users = () => {

    const githubContext = useContext(GithubContext);

    const {users , loading} = githubContext;
            
            if(loading){
              return <Spinner />
            }
            else{
               return ( 
                <div style={UserStyle}>
                 {users.map(user => (
                  <UserItem key={user.id} user={user}/>
                 ))} 
                </div>
               )
            }    
}

const UserStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3,1fr)',
    gridGap: '1rem'
}

Users.prototype = {
    users: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
}

export default Users
